module.exports = __webpack_public_path__ + "static/media/busy.32772def.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/busy.svg
// module id = 588
// module chunks = 0